import apiClient from '../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../common/functions/errorHandler.function';

const unwrapResponse = (response) => response.data?.response ?? response.data;

export const searchInvoiceAttachments = async (search = '') => {
  try {
    const response = await apiClient.get('/invoiceAttachmentManagement/invoices', {
      params: { search },
    });
    const result = unwrapResponse(response);
    return Array.isArray(result) ? result : [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getInvoiceAttachments = async (invoiceId) => {
  try {
    const response = await apiClient.get(`/invoiceAttachmentManagement/invoices/${invoiceId}`);
    return unwrapResponse(response);
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const uploadInvoicePoFile = async (invoiceId, file, onProgress) => {
  try {
    const formData = new FormData();
    formData.append('poFile', file);
    const response = await apiClient.post(
      `/invoiceAttachmentManagement/invoices/${invoiceId}/po-file`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress,
      }
    );
    return unwrapResponse(response);
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const uploadInvoiceOtherDocuments = async (invoiceId, files, onProgress) => {
  try {
    const formData = new FormData();
    files.forEach((file) => formData.append('otherDocuments', file));
    const response = await apiClient.post(
      `/invoiceAttachmentManagement/invoices/${invoiceId}/other-documents`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress,
      }
    );
    return unwrapResponse(response);
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
